import { render, staticRenderFns } from "./PreviewForm.vue?vue&type=template&id=1c4938f5&"
import script from "./PreviewForm.vue?vue&type=script&lang=ts&"
export * from "./PreviewForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports